// extracted by mini-css-extract-plugin
export default {"container":"rules_page_container__-RGMz","backButton":"rules_page_backButton__8+wkM","ruleList":"rules_page_ruleList__rCwps"};